var _inherits = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).GooglePayButton = t(e.React);
}(this, function (e) {
  "use strict";

  function t(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var n = t(e);
  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
  
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
  
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */

  function o(e, t, n, o) {
    return new (n || (n = Promise))(function (i, a) {
      function s(e) {
        try {
          l(o.next(e));
        } catch (e) {
          a(e);
        }
      }

      function r(e) {
        try {
          l(o.throw(e));
        } catch (e) {
          a(e);
        }
      }

      function l(e) {
        var t;
        e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(s, r);
      }

      l((o = o.apply(e, t || [])).next());
    });
  }

  var i = {};

  function a(e) {
    var t = i[e];
    if (t) return t;
    var n = new Promise(function (t, n) {
      var o = document.createElement("script");
      o.src = e, o.async = !0;

      var a = function a() {
        t();
      },
          s = function s() {
        o.removeEventListener("load", a), o.removeEventListener("error", s), delete i[e], o.remove(), n(new Error("Unable to load script " + e));
      };

      o.addEventListener("load", a), o.addEventListener("error", s), document.body.appendChild(o);
    });
    return i[e] = n, n;
  }

  var s = /*#__PURE__*/function () {
    function s(e) {
      var _this = this;

      _classCallCheck(this, s);

      this.handleClick = function (e) {
        return o(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var t, n, _o;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  t = this.config;

                  if (t) {
                    _context.next = 3;
                    break;
                  }

                  throw new Error("google-pay-button: Missing configuration");

                case 3:
                  n = this.createLoadPaymentDataRequest(t);
                  _context.prev = 4;

                  if (!(t.onClick && t.onClick(e), e.defaultPrevented)) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt("return");

                case 7:
                  _context.next = 9;
                  return this.client.loadPaymentData(n);

                case 9:
                  _o = _context.sent;
                  t.onLoadPaymentData && t.onLoadPaymentData(_o);
                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](4);
                  "CANCELED" === _context.t0.statusCode ? t.onCancel && t.onCancel(_context.t0) : t.onError ? t.onError(_context.t0) : console.error(_context.t0);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[4, 13]]);
        }));
      }, this.options = e;
    }

    _createClass(s, [{
      key: "getElement",
      value: function getElement() {
        return this.element;
      }
    }, {
      key: "isGooglePayLoaded",
      value: function isGooglePayLoaded() {
        var e, t;
        return "google" in (window || global) && !!(null === (t = null === (e = null === google || void 0 === google ? void 0 : google.payments) || void 0 === e ? void 0 : e.api) || void 0 === t ? void 0 : t.PaymentsClient);
      }
    }, {
      key: "mount",
      value: function mount(e) {
        return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = this.isGooglePayLoaded();

                  if (_context2.t0) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return a("https://pay.google.com/gp/p/js/pay.js");

                case 4:
                  this.element = e;
                  e && (this.appendStyles(), this.config && this.updateElement());

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      }
    }, {
      key: "unmount",
      value: function unmount() {
        this.element = void 0;
      }
    }, {
      key: "configure",
      value: function configure(e) {
        var t = void 0;
        return this.config = e, this.oldInvalidationValues && !this.isClientInvalidated(e) || (t = this.updateElement()), this.oldInvalidationValues = this.getInvalidationValues(e), null != t ? t : Promise.resolve();
      }
    }, {
      key: "createClientOptions",
      value: function createClientOptions(e) {
        var t = {
          environment: e.environment,
          merchantInfo: this.createMerchantInfo(e)
        };
        return (e.onPaymentDataChanged || e.onPaymentAuthorized) && (t.paymentDataCallbacks = {}, e.onPaymentDataChanged && (t.paymentDataCallbacks.onPaymentDataChanged = function (t) {
          return e.onPaymentDataChanged(t) || {};
        }), e.onPaymentAuthorized && (t.paymentDataCallbacks.onPaymentAuthorized = function (t) {
          return e.onPaymentAuthorized(t) || {};
        })), t;
      }
    }, {
      key: "createIsReadyToPayRequest",
      value: function createIsReadyToPayRequest(e) {
        var t = e.paymentRequest;
        return {
          apiVersion: t.apiVersion,
          apiVersionMinor: t.apiVersionMinor,
          allowedPaymentMethods: t.allowedPaymentMethods,
          existingPaymentMethodRequired: e.existingPaymentMethodRequired
        };
      }
    }, {
      key: "createLoadPaymentDataRequest",
      value: function createLoadPaymentDataRequest(e) {
        return Object.assign(Object.assign({}, e.paymentRequest), {
          merchantInfo: this.createMerchantInfo(e)
        });
      }
    }, {
      key: "createMerchantInfo",
      value: function createMerchantInfo(e) {
        var t = Object.assign({}, e.paymentRequest.merchantInfo);
        return t.softwareInfo || (t.softwareInfo = {
          id: this.options.softwareInfoId,
          version: this.options.softwareInfoVersion
        }), t;
      }
    }, {
      key: "isMounted",
      value: function isMounted() {
        return null != this.element && !1 !== this.element.isConnected;
      }
    }, {
      key: "removeButton",
      value: function removeButton() {
        if (this.element instanceof ShadowRoot || this.element instanceof Element) for (var _i = 0, _Array$from = Array.from(this.element.children); _i < _Array$from.length; _i++) {
          var _e = _Array$from[_i];
          "STYLE" !== _e.tagName && _e.remove();
        }
      }
    }, {
      key: "updateElement",
      value: function updateElement() {
        return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var e, t, n, o, i, a, _e2;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (this.isMounted()) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  e = this.getElement();

                  if (this.config) {
                    _context3.next = 5;
                    break;
                  }

                  throw new Error("google-pay-button: Missing configuration");

                case 5:
                  this.removeButton(), this.client = new google.payments.api.PaymentsClient(this.createClientOptions(this.config));
                  t = {
                    buttonType: this.config.buttonType,
                    buttonColor: this.config.buttonColor,
                    buttonSizeMode: this.config.buttonSizeMode,
                    buttonLocale: this.config.buttonLocale,
                    onClick: this.handleClick,
                    allowedPaymentMethods: this.config.paymentRequest.allowedPaymentMethods
                  }, n = e.getRootNode();
                  n instanceof ShadowRoot && (t.buttonRootNode = n);
                  o = this.client.createButton(t);
                  this.setClassName(e, [e.className, "not-ready"]), e.appendChild(o);
                  a = !1;
                  _context3.prev = 11;
                  _context3.next = 14;
                  return this.client.isReadyToPay(this.createIsReadyToPayRequest(this.config));

                case 14:
                  i = _context3.sent;
                  a = i.result && !this.config.existingPaymentMethodRequired || i.result && i.paymentMethodPresent && this.config.existingPaymentMethodRequired || !1;
                  _context3.next = 21;
                  break;

                case 18:
                  _context3.prev = 18;
                  _context3.t0 = _context3["catch"](11);
                  this.config.onError ? this.config.onError(_context3.t0) : console.error(_context3.t0);

                case 21:
                  if (this.isMounted()) {
                    if (a) {
                      try {
                        this.client.prefetchPaymentData(this.createLoadPaymentDataRequest(this.config));
                      } catch (e) {
                        console.log("Error with prefetch", e);
                      }

                      this.setClassName(e, (e.className || "").split(" ").filter(function (e) {
                        return e && "not-ready" !== e;
                      }));
                    }

                    if ((this.isReadyToPay !== (null == i ? void 0 : i.result) || this.paymentMethodPresent !== (null == i ? void 0 : i.paymentMethodPresent)) && (this.isReadyToPay = !!(null == i ? void 0 : i.result), this.paymentMethodPresent = null == i ? void 0 : i.paymentMethodPresent, this.config.onReadyToPayChange)) {
                      _e2 = {
                        isButtonVisible: a,
                        isReadyToPay: this.isReadyToPay
                      };
                      this.paymentMethodPresent && (_e2.paymentMethodPresent = this.paymentMethodPresent), this.config.onReadyToPayChange(_e2);
                    }
                  }

                case 22:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[11, 18]]);
        }));
      }
    }, {
      key: "setClassName",
      value: function setClassName(e, t) {
        var n = t.filter(function (e) {
          return e;
        }).join(" ");
        n ? e.className = n : e.removeAttribute("class");
      }
    }, {
      key: "appendStyles",
      value: function appendStyles() {
        var e, t, n;
        if ("undefined" == typeof document) return;
        var o = null === (e = this.element) || void 0 === e ? void 0 : e.getRootNode(),
            i = "default-google-style-".concat(this.options.cssSelector.replace(/[^\w-]+/g, ""), "-").concat(null === (t = this.config) || void 0 === t ? void 0 : t.buttonLocale);

        if (o && !(null === (n = o.getElementById) || void 0 === n ? void 0 : n.call(o, i))) {
          var _e3 = document.createElement("style");

          _e3.id = i, _e3.type = "text/css", _e3.innerHTML = "\n          ".concat(this.options.cssSelector, " {\n            display: inline-block;\n          }\n          ").concat(this.options.cssSelector, ".not-ready {\n            width: 0;\n            height: 0;\n            overflow: hidden;\n          }\n        "), o instanceof Document && o.head ? o.head.appendChild(_e3) : o.appendChild(_e3);
        }
      }
    }, {
      key: "isClientInvalidated",
      value: function isClientInvalidated(e) {
        var _this2 = this;

        if (!this.oldInvalidationValues) return !0;
        return this.getInvalidationValues(e).some(function (e, t) {
          return e !== _this2.oldInvalidationValues[t];
        });
      }
    }, {
      key: "getInvalidationValues",
      value: function getInvalidationValues(e) {
        var t, n;
        return [e.environment, e.existingPaymentMethodRequired, !!e.onPaymentDataChanged, !!e.onPaymentAuthorized, e.buttonColor, e.buttonType, e.buttonLocale, e.buttonSizeMode, e.paymentRequest.merchantInfo.merchantId, e.paymentRequest.merchantInfo.merchantName, null === (t = e.paymentRequest.merchantInfo.softwareInfo) || void 0 === t ? void 0 : t.id, null === (n = e.paymentRequest.merchantInfo.softwareInfo) || void 0 === n ? void 0 : n.version, e.paymentRequest.allowedPaymentMethods];
      }
    }]);

    return s;
  }();

  var r = "google-pay-button-container";

  var l = /*#__PURE__*/function (_n$default$Component) {
    _inherits(l, _n$default$Component);

    var _super = _createSuper(l);

    function l() {
      var _this3;

      _classCallCheck(this, l);

      _this3 = _super.apply(this, arguments), _this3.manager = new s({
        cssSelector: "." + r,
        softwareInfoId: "@google-pay/button-react",
        softwareInfoVersion: "2.6.0"
      }), _this3.elementRef = n.default.createRef();
      return _this3;
    }

    _createClass(l, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var e;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  e = this.elementRef.current;
                  _context4.t0 = e;

                  if (!_context4.t0) {
                    _context4.next = 6;
                    break;
                  }

                  _context4.next = 5;
                  return this.manager.mount(e);

                case 5:
                  this.manager.configure(this.props);

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.manager.unmount();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.manager.configure(this.props);
      }
    }, {
      key: "render",
      value: function render() {
        return n.default.createElement("div", {
          ref: this.elementRef,
          className: [r, this.props.className].filter(function (e) {
            return e;
          }).join(" "),
          style: this.props.style
        });
      }
    }]);

    return l;
  }(n.default.Component);

  return l;
});